import Header from "../components/Header"  
import ButtonNavigation from "../components/ButtonNavigation"
import BottomRoundButton from "../components/BottomRoundButton" 
import { Outlet } from "react-router-dom"

export default function RootLayout() {
    return (<>
        <div className="container bg-background-300 pb-20">
            <Outlet />
            <ButtonNavigation />
        </div>
    </>)
};